import AdminAddDesignationForm from 'components/form/admin/master/designation/AdminAddDesignationForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class AdminAddDesignation extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Designation</h4>
                                <AdminAddDesignationForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
